import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  Group,
  Grid,
  ScrollArea,
  createStyles,
  rem,
  Alert,
  Indicator,
  Avatar,
} from "@mantine/core";
import { FileText, Stack2 } from "tabler-icons-react";
import intl from "react-intl-universal";
import UserSignDocStatus from "./helper/UserSignDocStatus";
import { useStapelDocumentCount } from "./helper/useStapelDocumentCount";


const useStyles = createStyles(() => ({
  textsize: {
    fontSize: rem("16px"),
  },
}));

export function DocInMeeting(props: any) {
  const { classes } = useStyles();

  const { getStapelCountForDocument } = useStapelDocumentCount();

  /* =====================
     REDUX
  ===================== */

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const meetingDocs =
    useSelector((state: any) => state.user.meetingdocs) || [];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stapelDocs =
    useSelector((state: any) => state.user.userhavetostapelsigndocs) || [];

  const meUserId =
    useSelector((state: any) => state.user.meuser.userId);

  const meParticipantId =
    useSelector((state: any) => state.user.meuser.id);

  /* =====================
     STAPEL RESOURCE IDS
     participantId → meetinguser.id
  ===================== */

  const stapelResourceIds = useMemo(() => {
    return (Array.isArray(stapelDocs)
      ? stapelDocs
      : Object.values(stapelDocs)
    )
      .filter((s: any) => s.participantId === meParticipantId)
      .flatMap(
        (s: any) =>
          s.documentsSignModes?.map(
            (d: any) => d.resourceId
          ) || []
      );
  }, [stapelDocs, meParticipantId]);

  /* =====================
     SINGLE SIGN RESOURCE IDS
     🔥 AUS meetingdocs.signers
  ===================== */

  const singleSignResourceIds = useMemo(() => {
    return meetingDocs
      .filter(
        (doc: any) =>
          Array.isArray(doc.signers) &&
          doc.signers.includes(meUserId)
      )
      .map((doc: any) => doc.resourceId);
  }, [meetingDocs, meUserId]);

  /* =====================
     DOCS TO SHOW
     (Single ODER Stapel)
  ===================== */

  let docsToShow = useMemo(() => {
    return meetingDocs.filter(
      (doc: any) =>
        singleSignResourceIds.includes(doc.resourceId) ||
        stapelResourceIds.includes(doc.resourceId)
    );
  }, [meetingDocs, singleSignResourceIds, stapelResourceIds]);

 

  /* =====================
     RENDER
  ===================== */

  if (docsToShow.length === 0) {
    docsToShow = meetingDocs
    /*return (
      <Alert title={intl.get("NOTIF_INFO_HEADER")}>
        {intl.get("KLIENT_COCLIST_NODOCS")}
      </Alert>
    );*/
  }

  const rows = docsToShow.map((item: any) => {
    const isStapel = stapelResourceIds.includes(item.resourceId);
    const stapelCount = getStapelCountForDocument(item.resourceId);

    return (
      <React.Fragment key={item.resourceId}>
        {props.view !== "small" && (
          <>
            <Grid>
              <Grid.Col xs={2}>
               
                    {!isStapel && (
                    <FileText size={48} strokeWidth={1} />
                  )}

                  {isStapel && stapelCount <= 1 && (
                    <Stack2 size={48} strokeWidth={1} />
                  )}

                  {isStapel && stapelCount > 1 && (
                    <Indicator
                      label={stapelCount}
                      size={16}
                      color="green"
                      position="bottom-end"
                      offset={4}
                      
                    >
                      <Avatar
                        size={48}
                        radius="xl"
                        variant="light"
                      >
                        <Stack2 size={48} strokeWidth={1} />
                      </Avatar>
                    </Indicator>
                  )}

               
              </Grid.Col>

              <Grid.Col xs={8}>
                <span className={classes.textsize}>
                  {item.name}
                </span>
              </Grid.Col>

              <Grid.Col xs={2}>
                <Group position="right">
                  <UserSignDocStatus
                    resourceId={item.resourceId}
                  />
                </Group>
              </Grid.Col>
            </Grid>
            <hr />
          </>
        )}

        {props.view === "small" && (
          <Group position="right">
            <UserSignDocStatus
              resourceId={item.resourceId}
              view="small"
              docname={item.name}
            />
          </Group>
        )}
      </React.Fragment>
    );
  });

  return props.view !== "small" ? (
    <ScrollArea
        h={300}
        offsetScrollbars
        scrollbarSize={8}
        styles={{
          viewport: {
            overflowX: "hidden",
          },
        }}
      >
    {rows}
  </ScrollArea>
  ) : (
    <>{rows}</>
  );
}





